/**
 * 资源增删改
 * 定义接口
 */
const IEMapService = require('./IEMapService');
/**
 * @classdesc 资源记录维护服务接口
 * @alias G.service.IResourceCurdService
 * @augments G.service.IEMapService
 * @param opts
 * @param opts.httpRequest {G.base.IHttpRequest} 请求对象
 * @param opts.url {String} 服务地址
 */
class IResourceCurdService extends IEMapService {
    constructor(opts) {
        super(opts);
    }

}
module.exports = IResourceCurdService;